import { getUserInfo } from "../api";

let _resolve;
let _ready = false;

/**
 * 等待用户信息初始化完成的 Promise。
 * 各页面在 onMounted 中 await 此 Promise 后再发起业务接口调用，
 * 保证 token + 用户信息已经就绪。
 */
export const userReady = new Promise((resolve) => {
  _resolve = resolve;
});

/**
 * 从 API 获取用户信息并缓存到 localStorage。
 * 仅在 App.vue 的 router.isReady() 中调用一次。
 */
export async function initUser() {
  if (_ready) return getUser();

  const token = localStorage.getItem("token");
  if (!token) {
    _ready = true;
    _resolve(getUser());
    return getUser();
  }

  try {
    const res = await getUserInfo();
    const glpLogin = {
      nickName: res.nickName,
      mobile: res.mobile,
      userId: res.id,
      companyId: res.companyId,
      portrait: { resourcesUrl: res.headImgUrl },
    };
    localStorage.setItem("glpLogin", JSON.stringify(glpLogin));
  } catch (e) {
    console.error("initUser failed:", e);
  }

  _ready = true;
  _resolve(getUser());
  return getUser();
}

/**
 * 同步读取本地缓存的用户信息，适用于非首次获取的场景。
 */
export function getUser() {
  try {
    return JSON.parse(localStorage.getItem("glpLogin")) || {};
  } catch {
    return {};
  }
}
